const AWS_RESPONSE_CONTENT_TYPE = "application/xml";

export async function parseAwsUploadResponse(res: Response) {
  const contentType = res.headers.get("content-type");
  if (contentType !== AWS_RESPONSE_CONTENT_TYPE) {
    throw new Error(
      `Expected a '${AWS_RESPONSE_CONTENT_TYPE}' response from AWS, got '${contentType}'.`
    );
  }
  const data = await res.text();
  const urlMatch = data.match(/<location>(.+)<\/location>/is);
  const missingUrlError = new Error(
    "The AWS response does not contain the URL of the uploaded file."
  );
  if (!urlMatch) {
    throw missingUrlError;
  }
  const url = urlMatch[1].trim();
  if (!url) {
    throw missingUrlError;
  }
  return url;
}
